import { BrandPage } from './dumb.js';
import enhance from './enhancer';

export default enhance(BrandPage);
